import {
  ADDRESSES_REQUEST_FAIL,
  ADDRESSES_REQUEST_SUCCESS,
  SELECT_ADDRESSES
} from '../action.types';
import initialState from '../initial.state';

export default function (state = initialState.addresses, action) {
  switch (action.type) {
    case ADDRESSES_REQUEST_SUCCESS:
      return { ...action.payload };
    case ADDRESSES_REQUEST_FAIL:
      return state;
    case SELECT_ADDRESSES:
      return [...action.addresses];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/address/addresses.reducer.js